import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path d="M17.071 2.929A9.935 9.935 0 0010 0a9.935 9.935 0 00-7.071 2.929A9.935 9.935 0 000 10a9.935 9.935 0 002.929 7.071A9.935 9.935 0 0010 20a9.935 9.935 0 007.071-2.929A9.935 9.935 0 0020 10a9.935 9.935 0 00-2.929-7.071zm1.342 6.42l-3.98 3.98-1.106-1.107 4.73-4.73c.185.594.306 1.216.356 1.858zm-1.017-3.406l-5.174 5.174-1.132-1.132 5.386-5.387c.348.417.657.867.92 1.345zM10.781 1.6c.59.054 1.16.169 1.709.338L10.78 3.646V1.599zm0 4.256l3.26-3.26c.472.259.916.56 1.328.9L10.78 8.084V5.855zM10 18.437c-4.652 0-8.438-3.785-8.438-8.437 0-4.389 3.37-8.005 7.657-8.401v8.725l6.166 6.166A8.399 8.399 0 0110 18.438zm6.49-3.052l-.952-.951 2.726-2.725a8.413 8.413 0 01-1.774 3.676z"></path>
        </svg>
    );
}